<div
  class="candidate-grid"
  [class.is-disabled]="selectionEnabled && selectionDisabled"
  [attr.aria-busy]="selectionEnabled && selectionDisabled">
  @for (candidate of displayCandidates; track candidate.id) {
    <app-candidate-card
      [candidate]="candidate"
      [selectionMode]="selectionEnabled"
      [selected]="isCandidateSelected(getCandidateSelectionValue(candidate))"
      [disabled]="selectionDisabled"
      (candidateClick)="handleCandidateClick($event)">
    </app-candidate-card>
  }
</div>
